module.exports = __webpack_public_path__ + "static/media/花泽香菜（加长版）.e4e4ae59.png";